const ModelFilter = {
  data() {
    return {
      activeModels: this.activeItems
    }
  },
  props: [
    'activeItems'
  ],
  watch: {
    activeItems(newValue) {
      this.activeModels = newValue
    }
  },
  methods: {
    handleInput: function(event) {
      bus.$emit('model_filter', event.target.value)
    },
  }
}

export default ModelFilter
